import { ICommonListResourceServiceQueryData } from './common-base-list-resource.service';

export const COMMON_LIST_RESOURCE_DEFAULT_REQUEST_PARAMS: ICommonListResourceServiceQueryData = {
	Page: 1,
	PageSize: 20,
};
